<template>
  <div class="p-b-5 p-b-2:mo">
    <div
        @click.prevent="onClick()"
        class="d-flex jc-between cur-pointer p-x-1:mo p-b-5 p-b-2:mo">
      <div class="h4 text-bold SECTION-TITLE">
        {{sectionTitle}}
      </div>
      <span class="LINER"/>
      <div class="ARROW">
        <vk-icon v-if="isOpen" name="chevronup"/>
        <vk-icon v-else name="chevrondown"/>
      </div>
    </div>
    <div :class="[isVisible ? 'SUB-SECTION' : 'CLOSED-SUB-SECTION']">
      <div v-if="isOpen">
        <div
            v-for="(item, index) in subSection.articles"
            :key="index"
            class="d-flex fd-column">
          <whats-new-item
              :open-image-modal="openImageModal"
              :content="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import capitalize from '@/filters/capitalize';
import WhatsNewItem from './WhatsNewItem';

export default {
  name: 'whats-new-sub-section',

  components: {
    WhatsNewItem,
  },
  props: {
    openImageModal: {
      type: Function,
    },
    subSection: {
      type: Object,
      default () { return {}; },
    },
  },
  data () {
    return {
      isOpen: true,
      isVisible: true,
    };
  },
  computed: {
    sectionTitle () {
      if (this.subSection.title) {
        if (new Date(this.subSection.title).valueOf()) {
          const title = this.subSection.title.split('-');
          return format(new Date(title[0], title[1] - 1), 'MMMM yyyy');
        }
        return capitalize(this.subSection.title);
      }
    },
  },
  watch: {
    subSection () {
      this.isOpen = true;
      this.isVisible = true;
    },
  },
  methods: {
    onClick () {
      if (this.isOpen) {
        this.isVisible = false;
        setTimeout(() => {
          this.isOpen = false;
        }, 400);
      } else {
        this.isOpen = true;
        setTimeout(() => {
          this.isVisible = true;
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.SECTION-TITLE {
  white-space: nowrap;
  color: $color-gray80;
}
.LINER {
  bottom:50%;
  content: '';
  width: 100%;
  height: 2px;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 5px;
  background-color: $color-gray80;
}
.ARROW {
  margin: 10px 12px 5px 0px;
  color: $color-depot;
}
.SUB-SECTION {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}
.CLOSED-SUB-SECTION {
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
</style>
